import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  toggleIcon: {
    color: '#444',
    backgroundColor: '#f5f6fa',
    borderRadius: '24px',
    margin: '0px 4px',
    border: '3px dashed #f5f6fa',
    '&:hover': {
      color: '#ff5a0f',
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e099',
      color: '#d1af9f',
      border: '3px solid #d1af9f',
    },
    width: '42px',
    height: '42px',
  },
  toggleIconActive: {
    border: '3px dashed #ff5a0f',
    color: '#444',
    backgroundColor: '#f5f6fa',
    borderRadius: '24px',
    margin: '0px 4px',
    '&:hover': {
      border: '3px dashed #ff5a0f',
      color: '#ff5a0f',
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e099',
      color: '#d1af9f',
      border: '3px solid #d1af9f',
    },
    width: '42px',
    height: '42px',
  },
}));

export default useStyles;